// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3qicY","bigColWidth":"Table_bigColWidth__11AvO","biggerColWidth":"Table_biggerColWidth__2vi2W","row":"Table_row__2MuMP","col":"Table_col__K2uui"};